<div
    class="flex flex-col h-full h-full bg-white rounded-2xl shadow-fm ml-auto overflow-hidden"
    [ngClass]="{ 'md:w-[224px] lg:w-[264px] xl:w-[280px]': panelOpen, 'w-16': !panelOpen }">
    <fm-right-panel-header
        [showBackButton]="(contentStackService.currentConstentStackSize$ | async) > 0"
        [showReloadButton]="currentContent?.showRefreshButton"
        [sendToMainPanelUrl]="currentContent?.sendToMainPanelUrl"
        [panelOpen]="panelOpen"
        (back)="contentStackService.popContent()"
        (refreshSelected)="onRefreshSelected()"
        (togglePanel)="onPanelToggled()">
    </fm-right-panel-header>

    <div class="w-full flex-1 overflow-hidden">
        @if (currentContent && panelOpen) {
            <ng-container
                *ngComponentOutlet="
                    currentContent.component;
                    inputs: currentContent.context
                "></ng-container>
        } @else {
            <fm-rp-home [panelOpen]="panelOpen" />
        }
    </div>
</div>
